import { updateArticleCurationState } from "modules/EmailBrowser/utils";
import { SEARCH_ARTICLES } from "../../../constants/actionTypes";
import * as interfaces from "../interfaces";

const searchState = {
  data: Array<interfaces.IArticlesItem>(),
  loading: false,
  page: 0,
  articlesCount: 0,
  sourcedContent: [{ data: "xiQ Global Pool", is_active: true, type: "global" }],
  excludedContent: [],
  excludedKeywords: [],
  includedKeywords: [],
  allSourcesUnchecked: false,
  advancedSearchResetCheck: false,
};

export const searchArticlesReducer = (state = searchState, action: interfaces.IArticlesAction) => {
  let newState = { ...state };
  switch (action.type) {
    case SEARCH_ARTICLES.LOAD_SUCCESS:
      newState.loading = false;
      newState.page = newState.page + 1;
      newState.articlesCount = action.article_count;
      if (action.offset === 0) newState.data = [...action.payload];
      else newState.data = [...state.data, ...action.payload];
      return newState;
    case SEARCH_ARTICLES.RESET_TOTAL_COUNT:
      newState.data = [];
      newState.articlesCount = 0;
      newState.page = 0;
      return newState;
    case SEARCH_ARTICLES.LOAD:
      newState.loading = true;
      return newState;
    case SEARCH_ARTICLES.LOAD_FAIL:
      newState.loading = false;
      return newState;
    case SEARCH_ARTICLES.FIRST_LOAD:
      newState.page = 1;
      newState.loading = true;
      newState.articlesCount = action.article_count;
      newState.data = [...action.payload];
      return newState;
    case SEARCH_ARTICLES.ADD_CURATE:
      newState.data = updateArticleCurationState(newState.data, action.curate_article_id, true);
      return newState;
    case SEARCH_ARTICLES.REMOVE_CURATE:
      newState.data = updateArticleCurationState(newState.data, action.curate_article_id, false);
      return newState;
    case SEARCH_ARTICLES.ADD_FAVOURITE:
      newState.data = state.data.filter((item) => {
        if (item.id === action.payload) {
          item.is_favourite = true;
        }
        return item;
      });
      return newState;
    case SEARCH_ARTICLES.REMOVE_FAVOURITE:
      newState.data = state.data.filter((item) => {
        if (item.id === action.payload) {
          item.is_favourite = false;
        }
        return item;
      });
      return newState;
    case SEARCH_ARTICLES.UPDATE_IS_CURATED:
      newState.data = state.data.map((item) => {
        action.payload.map((articleId: string) => {
          if (item.id.toString() === articleId) {
            item.is_curated = true;
          }
        });
        return item;
      });
      return newState;
    case SEARCH_ARTICLES.UPDATE_UNDO_IS_CURATED:
      newState.data = state.data.map((item) => {
        action.payload.map((articleId: string) => {
          if (item.id.toString() === articleId) {
            item.is_curated = false;
          }
        });
        return item;
      });
      return newState;
    case SEARCH_ARTICLES.SOURCE_CONTENT:
      newState.sourcedContent = action.payload;
      return newState;
    case SEARCH_ARTICLES.EXCLUDE_CONTENT:
      newState.excludedContent = action.payload;
      return newState;
    case SEARCH_ARTICLES.EXCLUDE_KEYWORDS:
      newState.excludedKeywords = action.payload;
      return newState;
    case SEARCH_ARTICLES.INCLUDED_KEYWORDS:
      newState.includedKeywords = action.payload;
      return newState;
    case SEARCH_ARTICLES.CLEAR_INCLUDED_KEYWORDS:
      newState.includedKeywords = [];
      return newState;

    case SEARCH_ARTICLES.RESET_ADVANCED_SEARCH:
      newState.sourcedContent = [{ data: "xiQ Global Pool", is_active: true, type: "global" }];
      newState.excludedContent = [];
      newState.excludedKeywords = [];
      newState.includedKeywords = [];
      return newState;

    case SEARCH_ARTICLES.ALL_SOURCES_UNCHECKED:
      newState.allSourcesUnchecked = action.payload;
      return newState;

    case SEARCH_ARTICLES.ADVANCED_SEARCH_RESET_CHECK:
      newState.advancedSearchResetCheck = !newState.advancedSearchResetCheck;
      return newState;

    default:
      return state;
  }
};

export const updateKeywordsReducer = (state = searchState, action: interfaces.IArticlesAction) => {
  let newState = { ...state };
  switch (action.type) {
    case SEARCH_ARTICLES.LOAD_SUCCESS:
      newState.loading = false;
      newState.page = newState.page + 1;
      newState.articlesCount = action.article_count;
      newState.data = [...state.data, ...action.payload];
      return newState;
    case SEARCH_ARTICLES.LOAD:
      newState.loading = true;
      return newState;
    case SEARCH_ARTICLES.LOAD_FAIL:
      newState.loading = false;
      return newState;
    case SEARCH_ARTICLES.FIRST_LOAD:
      newState.page = 1;
      newState.loading = true;
      newState.articlesCount = action.article_count;
      newState.data = [...action.payload];
      return newState;
    case SEARCH_ARTICLES.ADD_CURATE:
      newState.data = updateArticleCurationState(newState.data, action.curate_article_id, true);
      return newState;
    case SEARCH_ARTICLES.REMOVE_CURATE:
      newState.data = updateArticleCurationState(newState.data, action.curate_article_id, false);
      return newState;
    case SEARCH_ARTICLES.ADD_FAVOURITE:
      newState.data = state.data.filter((item) => {
        if (item.id === action.payload) {
          item.is_favourite = true;
        }
        return item;
      });
      return newState;
    case SEARCH_ARTICLES.REMOVE_FAVOURITE:
      newState.data = state.data.filter((item) => {
        if (item.id === action.payload) {
          item.is_favourite = false;
        }
        return item;
      });
      return newState;
    default:
      return state;
  }
};
